module.exports = __webpack_public_path__ + "static/media/meh-blank.7f34b609.svg";